export function EmptyInspector() {
  return (
    <div className='ee-insp__empty'>
      <div className='ee-insp__empty-icon'>⊕</div>
      <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6 }}>Select a block</div>
      <div style={{ fontSize: 12, color: 'var(--ink-500)' }}>
        Click any block in the canvas to edit its properties — layout, spacing, background and content.
      </div>
    </div>
  );
}
